module.exports = __webpack_public_path__ + "static/media/SG_Payslip_4.5b803819.png";